import React, { FC, useState } from 'react';
import { Button } from '@mui/material';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { CheckFilledIcon, CloseIcon, Modal } from 'src/shared/components';
import { LocalStorageEnums } from 'src/shared/enums';
import { useGetLegacyUrl, useThunkDispatch } from 'src/shared/hooks';
import { useTranslate } from 'src/shared/providers';
import { clearLocalStorageValues } from 'src/shared/utils';
import { RootState } from 'src/store/types';
import { updatePreferences } from 'src/store/user/user.actions';
import './DisplayPreferences.styles.scss';

export const DisplayExperienceForm: FC = () => {
  const { t } = useTranslate();
  const dispatch = useThunkDispatch();
  const [openModal, setOpenModal] = useState<boolean>(false);
  const { submittingPreferences } = useSelector((state: RootState) => state.user);
  const { redirectToLegacyApp, loading } = useGetLegacyUrl();

  const handleDefaultChange = async () => {
    try {
      await dispatch(updatePreferences({ essAutoRedirect: false }));

      setOpenModal(false);
      clearLocalStorageValues([LocalStorageEnums.THEME_MODE]);
      redirectToLegacyApp();
    } catch {
      toast.info(t('global.oopsAnErrorOccurredWhileProcessingYourRequest'), { type: toast.TYPE.ERROR });
    }
  };

  return (
    <div className="my-4 d-flex align-items-center flex-wrap">
      <div className="display-preferences-header">
        <p className="mb-0 fw-500">{t('absences.chooseExperience')}</p>
        <label className="text-muted d-block">
          {t('absences.controlWhichVersionOfThisApplicationYouWouldLikeToByDefault')}
        </label>
      </div>
      <div className="mt-3 mt-xl-0">
        <Button id="switch-to-agile-classic" color="secondary" onClick={() => setOpenModal(true)}>
          {t('absences.switchToAgileClassic')}
        </Button>
      </div>

      <Modal
        open={openModal}
        onClose={() => setOpenModal(false)}
        modalHeaderProps={{
          title: t('absences.areYouSure'),
          onClose: () => setOpenModal(false),
        }}
        modalFooterProps={{
          closeText: t('global.cancel'),
          closeIcon: <CloseIcon />,
          submitText: t('global.yes'),
          submitIcon: <CheckFilledIcon />,
          onClose: () => setOpenModal(false),
          onSubmit: handleDefaultChange,
          loading: submittingPreferences || loading,
        }}
      >
        <div className="mt-3">
          <p className="text-muted fw-400">
            {t('absences.theNextTimeYouLoginYouWillBePresentedWithTheAgileClassicView')}
          </p>
          <p className="text-muted mb-0">
            <span className="fw-500 me-1">{t('absences.pleaseNote')}</span>
            <span className="fw-400">{t('absences.youLlBeRedirectedToTheAgileClassicExperience')}</span>
          </p>
        </div>
      </Modal>
    </div>
  );
};
